type SearchParams = Record<string, string | string[] | undefined>

/**
 * Returns search params with the specified keys excluded
 *
 * @param searchParams - The search params object to filter
 * @param keysToExclude - Array of keys to exclude from the result
 * @returns A new search params object without the excluded keys
 *
 * @example
 * ```ts
 * filterSearchParams({ foo: '1', bar: '2', error_message: 'oops' }, ['error_message'])
 * // Returns: { foo: '1', bar: '2' }
 * ```
 */
export function filterSearchParams(searchParams: SearchParams, keysToExclude: string[]): SearchParams {
  const excludeSet = new Set(keysToExclude)
  return Object.fromEntries(Object.entries(searchParams).filter(([key]) => !excludeSet.has(key))) as SearchParams
}
